<template>
  <data-loader>
    <submit-section-modal
      v-if="showModal"
      submit-text="Proceed to next section"
      close-text="I'm not ready"
      @close-modal="showModal = false"
      @submit-section="goToNextSection"
    >
      <template #top-left-corner>
        <span>{{ formattedTime(timeLeftInSeconds) }}</span>
      </template>
      <p>
        ⚠️ <span class="warning">WARNING</span> ⚠️<br /><br />
        You still have time left in your break,<br />
        are you sure you want to start the next section?
      </p>
    </submit-section-modal>
    <full-page-modal
      header-text="Break"
      :content-text="section.breakText || 'Break text is configured in the legacy CMS for each section'"
      primary-button-text="Continue"
      @primary-button-click="continueButton"
    >
      <template #timer>
        <span>{{ formattedTime(timeLeftInSeconds) }}</span>
      </template>
    </full-page-modal>
  </data-loader>
</template>

<script>
import FullPageModal from '@components/sims/FullPageModal.vue';
import WuxSimulationsMixin from '@/mixins/wux-simulations';
import DataLoader from '@/components/sims/DataLoader.vue';
import SubmitSectionModal from '@components/sims/sectionReview/SubmitSectionModal.vue';
import AccommodationsMixin from '@/mixins/accommodations';

export default {
  components: {
    FullPageModal,
    DataLoader,
    SubmitSectionModal,
  },
  mixins: [WuxSimulationsMixin, AccommodationsMixin],
  data() {
    return {
      showModal: false,
      timeLeftInSeconds: null,
      timerInterval: null,
    };
  },
  mounted() {
    this.timerInterval = setInterval(() => {
      try {
        const breakTimeInMinutes = this.userBreakTime || this.section.breakTimeInMinutes;
        this.timerTick(this.completedStatus, breakTimeInMinutes);
      }
      catch {
        clearInterval(this.timerInterval);
      }
    }, 250);
  },
  beforeUnmount() {
    clearInterval(this.timerInterval);
  },
  methods: {
    continueButton() {
      if (this.timeLeftInSeconds > 0) {
        this.showModal = true;
      }
      else {
        this.goToNextSection();
      }
    },
    goToNextSection() {
      this.setCategoryState(this.nextSection, this.notStartedStatus);
      if (this.nextSectionId) {
        return this.$router.push({
          name: 'simSection#show',
          params: {
            simId: this.simId,
            sectionId: this.nextSectionId,
          },
        });
      }
    },
  },
};
</script>

<style lang="scss">
.submit-section-modal-content .warning {
  color: #ff0000;
  animation: blinker 2s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}
</style>
